import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import net.kigawa.admin.pages.CallbackPage as _net_kigawa_admin_pages_CallbackPage
import net.kigawa.admin.pages.GithubAppRoute as _net_kigawa_admin_pages_GithubAppRoute
import net.kigawa.admin.pages.HomePage as _net_kigawa_admin_pages_HomePage
import net.kigawa.admin.pages.InfrastructureRoute as _net_kigawa_admin_pages_InfrastructureRoute
import net.kigawa.admin.pages.NetworkMapRoute as _net_kigawa_admin_pages_NetworkMapRoute
import net.kigawa.admin.pages.OrganizationsRoute as _net_kigawa_admin_pages_OrganizationsRoute
import net.kigawa.admin.pages.UsersRoute as _net_kigawa_admin_pages_UsersRoute

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Admin Panel"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register(
            "/",
        ) { pageCtx -> 
            _net_kigawa_admin_pages_HomePage()
        }
        ctx.router.register(
            "/callback",
        ) { pageCtx -> 
            _net_kigawa_admin_pages_CallbackPage()
        }
        ctx.router.register(
            "/github-app",
        ) { pageCtx -> 
            _net_kigawa_admin_pages_GithubAppRoute()
        }
        ctx.router.register(
            "/infrastructure",
        ) { pageCtx -> 
            _net_kigawa_admin_pages_InfrastructureRoute()
        }
        ctx.router.register(
            "/network-map",
        ) { pageCtx -> 
            _net_kigawa_admin_pages_NetworkMapRoute()
        }
        ctx.router.register(
            "/organizations",
        ) { pageCtx -> 
            _net_kigawa_admin_pages_OrganizationsRoute()
        }
        ctx.router.register(
            "/users",
        ) { pageCtx -> 
            _net_kigawa_admin_pages_UsersRoute()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        net.kigawa.admin.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
